import React from 'react'

const RoleContext = React.createContext()

export default RoleContext